import { render, staticRenderFns } from "./ActivityFollowersAndVisitors.vue?vue&type=template&id=396d6104&"
import script from "./ActivityFollowersAndVisitors.vue?vue&type=script&lang=js&"
export * from "./ActivityFollowersAndVisitors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports